import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
import { ShieldCheck, Lock, CreditCard, FileText, Zap, Globe } from 'lucide-react';
export function Hero() {
  return <section className="bg-brand-dark text-white pt-6 pb-6 px-4 relative overflow-hidden" data-id="element-84">
      <div className="max-w-3xl mx-auto relative z-10 flex flex-col items-center text-center" data-id="element-85">
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-black mb-2 leading-tight text-white tracking-tight" data-id="element-86">
          Todo tu año de entrenamiento de{' '}
          <span className="text-brand-accent neon-glow" data-id="element-87">Vóley</span> resuelto.
        </h1>

        <div className="w-full max-w-[320px] md:max-w-md mx-auto my-3 cursor-pointer transform hover:scale-[1.02] transition-transform duration-300 relative" onClick={scrollToCompra} data-id="element-88">
          <div className="absolute inset-0 bg-brand-accent/15 blur-3xl rounded-full" data-id="element-89"></div>
          <img src="https://cdn.magicpatterns.com/uploads/4Kfrqqdmddpd6GpFyJDKjk/mockups_voley_.png" alt="Kit Completo Vóley Listo" className="w-full h-auto drop-shadow-2xl relative z-10" data-id="element-90" />
        </div>

        <h2 className="text-lg md:text-xl lg:text-2xl font-black mb-1 text-brand-accent neon-glow" data-id="element-91">
          "Listo para usar. Sin improvisar más."
        </h2>

        <p className="text-sm md:text-base mb-4 font-medium text-gray-300 max-w-lg mx-auto leading-relaxed" data-id="element-92">
          Planificá todo tu año de clases de vóley en una tarde — sin improvisar
          ni perder fines de semana buscando material.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mb-4 w-full" data-id="element-93">
          <div className="flex items-center bg-white/5 px-3 py-1.5 rounded-full border border-white/10 text-[10px] md:text-xs font-medium" data-id="element-94">
            <FileText className="w-3 h-3 mr-1.5 text-brand-accent" data-id="element-95" />
            <span data-id="element-96">100% PDF</span>
          </div>
          <div className="flex items-center bg-white/5 px-3 py-1.5 rounded-full border border-white/10 text-[10px] md:text-xs font-medium" data-id="element-97">
            <Zap className="w-3 h-3 mr-1.5 text-brand-accent" data-id="element-98" />
            <span data-id="element-99">Acceso inmediato</span>
          </div>
          <div className="flex items-center bg-white/5 px-3 py-1.5 rounded-full border border-white/10 text-[10px] md:text-xs font-medium" data-id="element-100">
            <Globe className="w-3 h-3 mr-1.5 text-brand-accent" data-id="element-101" />
            <span data-id="element-102">Toda Latinoamérica</span>
          </div>
        </div>

        <div className="w-full max-w-sm mx-auto mb-3" data-id="element-103">
          <Button className="text-base md:text-xl py-3 md:py-4 shadow-[0_0_30px_rgba(0,191,255,0.3)]" data-id="element-104">
            🏐 → QUIERO MI KIT AHORA
          </Button>
        </div>

        <div className="flex flex-wrap justify-center gap-3 md:gap-5 text-[10px] md:text-xs text-gray-400 font-medium" data-id="element-105">
          <div className="flex items-center" data-id="element-106">
            <ShieldCheck className="w-3 h-3 mr-1 text-brand-accent" data-id="element-107" />
            <span data-id="element-108">Garantía 7 días sin preguntas</span>
          </div>
          <div className="flex items-center" data-id="element-109">
            <Lock className="w-3 h-3 mr-1 text-brand-accent" data-id="element-110" />
            <span data-id="element-111">Pago 100% seguro</span>
          </div>
          <div className="flex items-center" data-id="element-112">
            <CreditCard className="w-3 h-3 mr-1 text-brand-accent" data-id="element-113" />
            <span data-id="element-114">Pagás en la moneda de tu país</span>
          </div>
        </div>
      </div>
    </section>;
}